module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/BannerSlider/BannerSlider-list/BannerSlider-list.component.css
// module id = ./src/app/BannerSlider/BannerSlider-list/BannerSlider-list.component.css
// module chunks = main